import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Grid,
  Modal,
  Form,
  Input,
  Select,
  Tag,
  Tooltip,
  Badge,
  Alert,
  Spin,
  Dropdown,
  message,
  Empty,
  Statistic,
  Divider, Popconfirm, Tabs, DatePicker, TimePicker, Table
} from 'antd';
import {
  HomeOutlined,PlusCircleOutlined,
  FilterOutlined,
  ReloadOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoginOutlined,
  LogoutOutlined,
  PlusOutlined,
  EyeOutlined,
  EditOutlined,
  MenuOutlined, DeleteOutlined, FileTextOutlined, ClockCircleOutlined, CalendarOutlined
} from '@ant-design/icons';
import axios from 'axios';
import './GobernantaPage.css';

import {BASE_URL} from '../utils/constants'

const { Title, Text } = Typography;
const { Option } = Select;
const { useBreakpoint } = Grid;
const { Countdown } = Statistic;
const { TextArea } = Input;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

const GobernantaPage = () => {
  const [habitaciones, setHabitaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedHab, setSelectedHab] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalType, setModalType] = useState(''); // 'detalle'
  const [filters, setFilters] = useState({
    piso: null,
    estado: null,
    incidencias: null,
    checkin: null,
    checkout: null
  });
  const screens = useBreakpoint();


    const [incidencias, setIncidencias] = useState([]);
    const [conteoIncidencias, setConteoIncidencias] = useState({});
    const [loadingIncidencias, setLoadingIncidencias] = useState(false);
    const [modalIncVisible, setModalIncVisible] = useState(false);
    const [modalIncType, setModalIncType] = useState(''); // 'list', 'add', 'edit'
    const [selectedIncidencia, setSelectedIncidencia] = useState(null);
    const [form] = Form.useForm();  
    
    const getNumHab = (hab) => {
    return typeof hab === 'object' ? hab.numhab : hab;
    };

    const fetchConteoIncidencias = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
        `${BASE_URL}/api/gobernanta/incidencias-conteo`,
        { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data.success) {
        setConteoIncidencias(response.data.conteo);
        }
    } catch (error) {
        console.error('Error obteniendo conteo de incidencias:', error);
    }
    };    

const fetchIncidencias = async (hab) => {
  setLoadingIncidencias(true);
  try {
    const numhab = getNumHab(hab); // Extraer el número
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `${BASE_URL}/api/gobernanta/incidencias/${numhab}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (response.data.success) {
      setIncidencias(response.data.incidencias);
    }
  } catch (error) {
    console.error('Error obteniendo incidencias:', error);
    message.error('Error al cargar las incidencias {fetchIncidencias}');
  } finally {
    setLoadingIncidencias(false);
  }
};


const handleCreateIncidencia = async (values) => {
  try {
    const numhab = getNumHab(selectedHab); // Extraer el número
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${BASE_URL}/api/gobernanta/incidencias`,
      {
        numhab: numhab,
        incidencia: values.descripcion,
        usuario: values.usuario || 'Sistema'
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (response.data.success) {
      message.success('Incidencia creada exitosamente');
      form.resetFields();
      fetchIncidencias(numhab); // Pasar el número
      fetchConteoIncidencias();
      if (modalIncType === 'add') {
        setModalIncVisible(false);
      }
    }
  } catch (error) {
    console.error('Error creando incidencia:', error);
    message.error('Error al crear la incidencia {handleCreateIncidencia}');
  }
};


const cambiarEstadoIncidencia = async (id, estado) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.put(
      `${BASE_URL}/api/gobernanta/incidencias/${id}/estado`,
      { estado },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (response.data.success) {
      message.success(response.data.message);
      fetchIncidencias(selectedHab); // Refrescar lista
      fetchConteoIncidencias(); // Actualizar conteo
    }
  } catch (error) {
    console.error('Error cambiando estado de incidencia:', error);
    message.error('Error al cambiar estado de la incidencia');
  }
};


const handleEditIncidencia = async (values) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.put(
      `${BASE_URL}/api/gobernanta/incidencias/${selectedIncidencia.AutoCodigo}`,
      { incidencia: values.descripcion },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (response.data.success) {
      message.success('Incidencia actualizada exitosamente');
      form.resetFields();
      setSelectedIncidencia(null);
      const numhab = getNumHab(selectedHab); // Extraer el número
      fetchIncidencias(numhab);
    }
  } catch (error) {
    console.error('Error editando incidencia:', error);
    message.error('Error al editar la incidencia');
  }
};


const handleDeleteIncidencia = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(
      `${BASE_URL}/api/gobernanta/incidencias/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (response.data.success) {
      message.success('Incidencia eliminada exitosamente');
      const numhab = getNumHab(selectedHab); // Extraer el número
      fetchIncidencias(numhab);
      fetchConteoIncidencias();
    }
  } catch (error) {
    console.error('Error eliminando incidencia:', error);
    message.error('Error al eliminar la incidencia');
  }
};
const columnsIncidencias = [
  {
    title: 'ID',
    dataIndex: 'AutoCodigo',
    key: 'id',
    width: 60,
    align: 'center'
  },
  {
    title: 'Fecha',
    dataIndex: 'Fecha',
    key: 'fecha',
    width: 100,
    render: (fecha) => fecha ? new Date(fecha).toLocaleDateString('es-ES') : '-'
  },
  {
    title: 'Hora',
    dataIndex: 'Hora',
    key: 'hora',
    width: 80
  },
  {
    title: 'Incidencia',
    dataIndex: 'Incidencia',
    key: 'incidencia',
    ellipsis: true,
    render: (text) => (
      <Tooltip title={text}>
        <span>{text}</span>
      </Tooltip>
    )
  },
  {
    title: 'Usuario',
    dataIndex: 'Usuario',
    key: 'usuario',
    width: 90
  },
  {
    title: 'Estado',
    dataIndex: 'Estado',
    key: 'estado',
    width: 100,
    render: (estado) => (
      <Tag color={estado === 0 ? 'orange' : 'green'} icon={estado === 0 ? <ClockCircleOutlined /> : <CheckCircleOutlined />}>
        {estado === 0 ? 'Pendiente' : 'Resuelta'}
      </Tag>
    )
  },
  {
    title: 'Acciones',
    key: 'acciones',
    width: 150,
    render: (_, record) => (
      <Space size="small">
        {/* Botón para cambiar estado */}
        {record.Estado === 0 ? (
          <Tooltip title="Marcar como resuelta">
            <Button
              size="small"
              type="primary"
              icon={<CheckCircleOutlined />}
              onClick={() => cambiarEstadoIncidencia(record.AutoCodigo, 1)}
            />
          </Tooltip>
        ) : (
          <Tooltip title="Reabrir incidencia">
            <Button
              size="small"
              icon={<CloseCircleOutlined />}
              onClick={() => cambiarEstadoIncidencia(record.AutoCodigo, 0)}
            />
          </Tooltip>
        )}
        
        {/* Botón para editar */}
        <Tooltip title="Editar">
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => {
              setSelectedIncidencia(record);
              form.setFieldsValue({
                descripcion: record.Incidencia
              });
              setModalIncType('edit');
            }}
          />
        </Tooltip>
        
        {/* Botón para eliminar */}
        <Popconfirm
          title="¿Eliminar esta incidencia?"
          onConfirm={() => handleDeleteIncidencia(record.AutoCodigo)}
          okText="Sí"
          cancelText="No"
        >
          <Tooltip title="Eliminar">
            <Button
              size="small"
              danger
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </Popconfirm>
      </Space>
    )
  }
];

const renderModalIncidencias = () => {
  if (!selectedHab) return null;

  // Obtener el número de habitación
  const numhab = getNumHab(selectedHab);
  
  return (
    <Modal
      title={`Incidencias - Habitación ${numhab}`} // Usar numhab
      open={modalIncVisible}
      onCancel={() => {
        setModalIncVisible(false);
        setModalIncType('');
        setSelectedIncidencia(null);
        form.resetFields();
      }}
      footer={null}
      width={800}
    >
      <Tabs
        activeKey={modalIncType}
        onChange={(key) => setModalIncType(key)}
        type="card"
      >
        {/* Pestaña de listado */}
        <TabPane tab="Lista de Incidencias" key="list">
          {loadingIncidencias ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <Spin tip="Cargando incidencias..." />
            </div>
          ) : incidencias.length === 0 ? (
            <Empty
              description="No hay incidencias para esta habitación"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          ) : (
            <>
              <Alert
                message={`Total de incidencias: ${incidencias.length}`}
                description={`Pendientes: ${incidencias.filter(i => i.Estado === 0).length} | Resueltas: ${incidencias.filter(i => i.Estado === 1).length}`}
                type="info"
                showIcon
                style={{ marginBottom: '16px' }}
              />
              <Table
                columns={columnsIncidencias}
                dataSource={incidencias}
                rowKey="AutoCodigo"
                size="small"
                pagination={{ pageSize: 5 }}
                scroll={{ x: 700 }}
              />
            </>
          )}
        </TabPane>

        {/* Pestaña para añadir incidencia */}
        <TabPane tab="Añadir Incidencia" key="add">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleCreateIncidencia}
          >
            <Form.Item
              name="descripcion"
              label="Descripción de la incidencia"
              rules={[{ required: true, message: 'Por favor describe la incidencia' }]}
            >
              <TextArea
                rows={6}
                placeholder="Describa detalladamente la incidencia..."
                maxLength={1000}
                showCount
              />
            </Form.Item>
            
            <Form.Item
              name="usuario"
              label="Reportado por (opcional)"
              initialValue="Sistema"
            >
              <Input placeholder="Nombre del usuario que reporta" />
            </Form.Item>

            <Form.Item>
              <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                <Button onClick={() => {
                  setModalIncType('list');
                  form.resetFields();
                }}>
                  Cancelar
                </Button>
                <Button type="primary" htmlType="submit">
                  Crear Incidencia
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </TabPane>

        {/* Pestaña para editar incidencia */}
        <TabPane 
          tab="Editar Incidencia" 
          key="edit"
          disabled={!selectedIncidencia}
        >
          {selectedIncidencia && (
            <Form
              form={form}
              layout="vertical"
              onFinish={handleEditIncidencia}
              initialValues={{
                descripcion: selectedIncidencia.Incidencia
              }}
            >
              <Alert
                message={`Editando incidencia #${selectedIncidencia.AutoCodigo}`}
                description={`Creada el ${selectedIncidencia.Fecha} a las ${selectedIncidencia.Hora} por ${selectedIncidencia.Usuario}`}
                type="info"
                showIcon
                style={{ marginBottom: '16px' }}
              />
              
              <Form.Item
                name="descripcion"
                label="Descripción de la incidencia"
                rules={[{ required: true, message: 'Por favor describe la incidencia' }]}
              >
                <TextArea
                  rows={6}
                  placeholder="Describa detalladamente la incidencia..."
                  maxLength={1000}
                  showCount
                />
              </Form.Item>

              <Form.Item>
                <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                  <Button onClick={() => {
                    setModalIncType('list');
                    setSelectedIncidencia(null);
                    form.resetFields();
                  }}>
                    Cancelar
                  </Button>
                  <Button type="primary" htmlType="submit">
                    Guardar Cambios
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          )}
        </TabPane>
      </Tabs>
    </Modal>
  );
};

        

  // Determinar tamaño de pantalla
  const isMobile = !screens.md;
  const isTablet = screens.md && !screens.lg;

  // Función para determinar estado visual basado en los datos
  const determinarEstadoVisual = (hab) => {
    // Si tiene CheckIn (no vacío)    
    
    if (hab.CheckIn && hab.CheckIn.trim() !== '') {
      return 'checkin';
    }
    
    // Si tiene CheckOut (no vacío)
    if (hab.CheckOut && hab.CheckOut.trim() !== '') {
      return 'checkout';
    }
    
    // Si tiene incidencias
    if (hab.Incidencias > 0) {
      return 'incidencia';
    }
    
    // Si no, usar el Estado numérico
    switch(hab.estado) {
      case 1: return 'sucia';
      case 0: return 'limpia';
      case 2: return 'bloqueada';
      case 4: return 'en-limpieza';
      case 3: return 'en-revision';
      default: return 'desconocido';
    }
  };

  // Colores por estado - BASADO EN DATOS REALES
  const estadoColors = {
    'sucia': '#ff4d4f',      // rojo - Estado 0
    'limpia': '#52c41a',     // verde - Estado 1
    'bloqueada':'#ffa8a8',
    'en-limpieza': '#1890ff', // azul - Estado 4
    'en-revision': '#fa8c16', // naranja - Estado 3
    'incidencia': '#faad14', // amarillo - Con incidencias
    'checkin': '#722ed1',    // púrpura - Con CheckIn
    'checkout': '#13c2c2',   // cyan - Con CheckOut
    'desconocido': '#8c8c8c' // gris
  };

  // Iconos por estado
  const estadoIcons = {
    'sucia': <CloseCircleOutlined style={{ color: estadoColors.sucia }} />,
    'limpia': <CheckCircleOutlined style={{ color: estadoColors.limpia }} />,
    'bloqueada': <CloseCircleOutlined style={{ color: estadoColors.bloqueada, fontSize: '24px' }} />,
    'en-limpieza': <ReloadOutlined spin style={{ color: estadoColors['en-limpieza'] }} />,
    'en-revision': <ExclamationCircleOutlined style={{ color: estadoColors['en-revision'] }} />,
    'incidencia': <ExclamationCircleOutlined style={{ color: estadoColors.incidencia }} />,
    'checkin': <LoginOutlined style={{ color: estadoColors.checkin }} />,
    'checkout': <LogoutOutlined style={{ color: estadoColors.checkout }} />,
    'desconocido': <ExclamationCircleOutlined style={{ color: estadoColors.desconocido }} />
  };

  // Textos descriptivos para cada estado
  const estadoDescriptions = {
    'sucia': 'Habitación sucia',
    'limpia': 'Habitación limpia',
     'bloqueada': 'Habitación bloqueada',  
    'en-limpieza': 'En proceso de limpieza',
    'en-revision': 'En revisión',
    'incidencia': 'Tiene incidencias pendientes',
    'checkin': 'Con Check-In pendiente',
    'checkout': 'Con Check-Out pendiente',
    'desconocido': 'Estado desconocido'
  };

  // Obtener todas las habitaciones
  const fetchHabitaciones = async () => {
    setLoading(true);
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${BASE_URL}/api/gobernanta/habitaciones`, {
        headers: { Authorization: `Bearer ${token}` }
        });

        if (response.data.success) {
        // Obtener conteo de incidencias
        await fetchConteoIncidencias();
        
        // Transformar datos con conteo de incidencias
        const habitacionesTransformadas = response.data.habitaciones.map(hab => ({
            ...hab,
            estadoVisual: determinarEstadoVisual(hab),
            // Agregar conteo de incidencias si existe
            IncidenciasCount: conteoIncidencias[hab.numhab] || 0
        }));
        // console.log(" habitacionesTransformadas => ",habitacionesTransformadas);
        
        setHabitaciones(habitacionesTransformadas);
        }
    } catch (error) {
        console.error('Error obteniendo habitaciones:', error);
        message.error('Error al cargar las habitaciones');
    } finally {
        setLoading(false);
    }
    };

  // Cargar habitaciones al montar
  useEffect(() => {
    fetchHabitaciones();
  }, []);

  // Filtrar habitaciones
  const filteredHabitaciones = habitaciones.filter(hab => {
    if (filters.piso && hab.piso !== filters.piso) return false;
    if (filters.estado && hab.estadoVisual !== filters.estado) return false;
    if (filters.incidencias === 'con' && hab.IncidenciasCount === 0) return false;
    if (filters.incidencias === 'sin' && hab.IncidenciasCount > 0) return false;
    if (filters.checkin === 'con' && (!hab.CheckIn || hab.CheckIn.trim() === '')) return false;
    if (filters.checkin === 'sin' && hab.CheckIn && hab.CheckIn.trim() !== '') return false;
    if (filters.checkout === 'con' && (!hab.CheckOut || hab.CheckOut.trim() === '')) return false;
    if (filters.checkout === 'sin' && hab.CheckOut && hab.CheckOut.trim() !== '') return false;
    return true;
  });

  // Agrupar por piso
  const habitacionesPorPiso = filteredHabitaciones.reduce((acc, hab) => {
    if (!acc[hab.piso]) {
      acc[hab.piso] = [];
    }
    acc[hab.piso].push(hab);
    return acc;
  }, {});

  // Calcular estadísticas
  const estadisticas = {
    total: habitaciones.length,
    sucias: habitaciones.filter(h => h.estado === 1).length,
    limpias: habitaciones.filter(h => h.estado === 0).length,
    bloqueadas: habitaciones.filter(h => h.estado === 2).length,
    enLimpieza: habitaciones.filter(h => h.estado === 4).length,
    enRevision: habitaciones.filter(h => h.estado === 3).length,
    conIncidencias: habitaciones.filter(h => h.IncidenciasCount > 0).length,
    conCheckIn: habitaciones.filter(h => h.CheckIn && h.CheckIn.trim() !== '').length,
    conCheckOut: habitaciones.filter(h => h.CheckOut && h.CheckOut.trim() !== '').length
  };

  // Menú contextual para habitación
  const getHabMenuItems = (habitacion) => {
    const items = [
      {
        key: 'detalle',
        label: 'Ver Detalles',
        icon: <EyeOutlined />,
        onClick: () => {
          setSelectedHab(habitacion);
          setModalType('detalle');
          setModalVisible(true);
        }
      },
      {type: 'divider'}
    ];

    const tieneIncidencias = conteoIncidencias[habitacion.numhab] > 0;
    items.push({
        key: 'ver-incidencias',
        label: tieneIncidencias ? `Ver Incidencias (${conteoIncidencias[habitacion.numhab]})` : 'Ver Incidencias',
        icon: <FileTextOutlined />,
        onClick: () => {
        setSelectedHab(habitacion);
        fetchIncidencias(habitacion);
        setModalIncType('list');
        setModalIncVisible(true);
        }
    });    

    items.push({
        key: 'añadir-incidencia',
        label: 'Añadir Incidencia',
        icon: <PlusOutlined />,
        onClick: () => {
                setSelectedHab(habitacion.numhab);
                setModalIncType('add');
                setModalIncVisible(true);
                form.resetFields();
        }
    });

    items.push({
        type: 'divider'
    });    

    // Opciones según estado
    if (habitacion.estado === 0) {
      // Si está limpia
      items.push({
        key: 'marcar-limpia',
        label: 'Marcar como sucia',
        icon: <CheckCircleOutlined />,
        onClick: () => cambiarEstadoHab(habitacion.numhab, 1)
      });
    } else if (habitacion.estado === 1) {
      // Si está sucia
      items.push({
        key: 'marcar-sucia',
        label: 'Marcar como limpia',
        icon: <CloseCircleOutlined />,
        onClick: () => cambiarEstadoHab(habitacion.numhab, 0)
      });
    }

    return items;
  };

  // Cambiar estado de habitación
  const cambiarEstadoHab = async (numhab, nuevoEstado) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${BASE_URL}/api/gobernanta/habitaciones/${numhab}/estado`,
        { nuevoEstado },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        message.success(response.data.message);
        fetchHabitaciones(); // Refrescar lista
      }
    } catch (error) {
      console.error('Error cambiando estado:', error);
      message.error('Error al cambiar estado de la habitación');
    }
  };

  // Renderizar tarjeta de habitación
    const renderHabitacionCard = (hab) => {
        const estadoVisual = hab.estadoVisual;
        const tieneIncidencias = conteoIncidencias[hab.numhab] > 0;
        
        return (
            <Dropdown
            menu={{ items: getHabMenuItems(hab) }}
            trigger={['contextMenu']}
            key={hab.numhab}
            >
            <Card
                hoverable
                onClick={() => {
                setSelectedHab(hab);
                setModalType('detalle');
                setModalVisible(true);
                }}
                style={{
                border: `2px solid ${estadoColors[estadoVisual]}`,
                borderRadius: '8px',
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.3s',
                backgroundColor: hab.estadoVisual === 'bloqueada' ? '#ffeaea' : 'white',
                position: 'relative'
                }}
                bodyStyle={{
                padding: '12px',
                textAlign: 'center'
                }}
            >
                {/* Badge de incidencias en esquina superior izquierda */}
                {tieneIncidencias && (
                <div style={{ 
                    position: 'absolute', 
                    top: '-8px', 
                    left: '-8px',
                    zIndex: 1 
                }}>
                    <Badge 
                    count={conteoIncidencias[hab.numhab]} 
                    style={{ 
                        backgroundColor: '#faad14',
                        boxShadow: '0 0 0 2px #fff',
                        fontSize: '10px',
                        fontWeight: 'bold'
                    }}
                    overflowCount={9}
                    />
                </div>
                )}

                {/* Badges superpuestos en esquina superior derecha */}
                <div style={{ position: 'absolute', top: '8px', right: '8px' }}>
                <Space size="small">
                    {hab.CheckIn && hab.CheckIn.trim() !== '' && (
                    <Tag color="purple" size="small" icon={<LoginOutlined />}>IN</Tag>
                    )}
                    {hab.CheckOut && hab.CheckOut.trim() !== '' && (
                    <Tag color="cyan" size="small" icon={<LogoutOutlined />}>OUT</Tag>
                    )}
                </Space>
                </div>

                {/* Número de habitación */}
                <div style={{
                fontSize: isMobile ? '20px' : '24px',
                fontWeight: 'bold',
                color: estadoColors[estadoVisual],
                marginTop: tieneIncidencias ? '15px' : '20px'
                }}>
                {hab.numhab}
                </div>

                {/* Icono de estado */}
                <div style={{ fontSize: '28px', margin: '8px 0' }}>
                {estadoIcons[estadoVisual]}
                </div>

                {/* Información adicional */}
                <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Text type="secondary" style={{ fontSize: '12px' }}>
                    Piso {hab.piso}
                </Text>
                <Text type="secondary" style={{ fontSize: '10px' }}>
                    {estadoDescriptions[estadoVisual]}
                </Text>
                
                {/* Líneas de salida/entrada */}
                {(hab.LineasS > 0 || hab.LineasE > 0) && (
                    <div style={{ marginTop: '4px' }}>
                    <Text type="secondary" style={{ fontSize: '10px' }}>
                        {hab.LineasS > 0 && `Salidas: ${hab.LineasS} `}
                        {hab.LineasE > 0 && `Entradas: ${hab.LineasE}`}
                    </Text>
                    </div>
                )}
                </Space>
            </Card>
            </Dropdown>
        );
    };

  // Renderizar habitaciones por piso
  const renderHabitaciones = () => {
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: '80px' }}>
          <Spin size="large" tip="Cargando habitaciones..." />
        </div>
      );
    }
    // console.log(" filteredHabitaciones => ",filteredHabitaciones);
    
    if (filteredHabitaciones.length === 0) {
      return (
        <Empty
          description={
            <span>
              No hay habitaciones que coincidan con los filtros<br />
              <Button type="link" onClick={() => setFilters({
                piso: null,
                estado: null,
                incidencias: null,
                checkin: null,
                checkout: null
              })}>
                Limpiar filtros
              </Button>
            </span>
          }
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      );
    }

    return Object.entries(habitacionesPorPiso).map(([piso, habs]) => (
      <div key={piso} style={{ marginBottom: '32px' }}>
        <Title level={4} style={{ marginBottom: '16px', color: '#2c3e50' }}>
          Piso {piso} ({habs.length} habitaciones)
        </Title>
        <Row gutter={[16, 16]}>
          {habs.map((hab) => (
            <Col
              key={hab.numhab}
              xs={12}
              sm={8}
              md={6}
              lg={4}
              xl={3}
            >
              {renderHabitacionCard(hab)}
            </Col>
          ))}
        </Row>
      </div>
    ));
  };

  // Renderizar modal de detalles
  const renderDetalleModal = () => {
    if (!selectedHab) return null;

    return (
      <Modal
        title={`Detalles - Habitación ${selectedHab.numhab}`}
        open={modalVisible && modalType === 'detalle'}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setModalVisible(false)}>
            Cerrar
          </Button>,
          selectedHab.estado === 0 || !selectedHab.estado ? (
            <Button 
              key="marcar-limpia" 
              type="primary" 
              icon={<CheckCircleOutlined />}
              onClick={() => {
                cambiarEstadoHab(selectedHab.numhab, 1);
                setModalVisible(false);
              }}
            >
              Marcar como sucia
            </Button>
          ) : selectedHab.estado === 1 ? (
            <Button 
              key="marcar-sucia" 
              type="primary" 
              danger 
              icon={<CloseCircleOutlined />}
              onClick={() => {
                cambiarEstadoHab(selectedHab.numhab, 0);
                setModalVisible(false);
              }}
            >
              Marcar como limpia
            </Button>
          ) : null
        ]}
        width={600}
      >
        <div style={{ padding: '16px 0' }}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Card size="small">
                <Row align="middle" gutter={16}>
                  <Col>
                    <div style={{ fontSize: '36px' }}>
                      {estadoIcons[selectedHab.estadoVisual]}
                    </div>
                  </Col>
                  <Col flex="1">
                    <Title level={4} style={{ margin: 0, color: estadoColors[selectedHab.estadoVisual] }}>
                      {estadoDescriptions[selectedHab.estadoVisual]}
                    </Title>
                    <Text type="secondary">Habitación {selectedHab.numhab} - Piso {selectedHab.piso}</Text>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col span={24}>
              <Card size="small" title="Información General">
                <Row gutter={[16, 8]}>
                  <Col span={12}>
                    <Text strong>Estado numérico:</Text>
                    <br />
                    <Tag color={selectedHab.estado === 0 ? 'red' : 'green'}>
                      {selectedHab.estado === 1 ? 'Sucia (1)' : selectedHab.estado === 0 ? 'Limpia (0)' : 
                       selectedHab.estado === 2 ? 'Bloqueada' :
                       selectedHab.estado === 4 ? 'En limpieza (4)' : 
                       selectedHab.estado === 3 ? 'En revisión (3)' : ''}
                    </Tag>
                  </Col>
                  <Col span={12}>
                    <Text strong>Incidencias:</Text>
                    <br />
                    <Tag color={selectedHab.Incidencias > 0 ? 'orange' : 'green'}>
                      {selectedHab.Incidencias > 0 ? `${selectedHab.Incidencias} pendientes` : 'Sin incidencias'}
                    </Tag>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Button 
                key="añadir-incidencia-detalle"
                type="primary" 
                onClick={() => {
                    setSelectedHab(selectedHab.numhab); // Pasar solo el número
                    setModalIncType('add');
                    setModalIncVisible(true);
                    form.resetFields();
                }}
                >
                Añadir incidencia
            </Button>
            <Button 
                key="ver-incidencias-detalle"
                type="primary" 
                onClick={() => {
                    setSelectedHab(selectedHab); // Pasar el objeto
                    fetchIncidencias(selectedHab); // Pasar el objeto
                    setModalIncType('list');
                    setModalIncVisible(true);
                }}
                >
                Ver incidencias
            </Button>         

            {(selectedHab.CheckIn || selectedHab.CheckOut) && (
              <Col span={24}>
                <Card size="small" title="Movimientos">
                  <Row gutter={[16, 8]}>
                    {selectedHab.CheckIn && selectedHab.CheckIn.trim() !== '' && (
                      <Col span={24}>
                        <Alert
                          message="Check-In Pendiente"
                          description={selectedHab.CheckIn}
                          type="info"
                          icon={<LoginOutlined />}
                          showIcon
                        />
                      </Col>
                    )}
                    {selectedHab.CheckOut && selectedHab.CheckOut.trim() !== '' && (
                      <Col span={24}>
                        <Alert
                          message="Check-Out Pendiente"
                          description={selectedHab.CheckOut}
                          type="warning"
                          icon={<LogoutOutlined />}
                          showIcon
                        />
                      </Col>
                    )}
                  </Row>
                </Card>
              </Col>
            )}

            {(selectedHab.LineasS > 0 || selectedHab.LineasE > 0 || selectedHab.LineasSalidas > 0 || selectedHab.LineasEntradas > 0) && (
              <Col span={24}>
                <Card size="small" title="Estadísticas de Líneas">
                  <Row gutter={[16, 8]}>
                    {selectedHab.LineasS > 0 && (
                      <Col span={12}>
                        <Statistic title="Líneas Salidas (S)" value={selectedHab.LineasS} />
                      </Col>
                    )}
                    {selectedHab.LineasSalidas > 0 && (
                      <Col span={12}>
                        <Statistic title="Líneas Salidas Totales" value={selectedHab.LineasSalidas} />
                      </Col>
                    )}
                    {selectedHab.LineasE > 0 && (
                      <Col span={12}>
                        <Statistic title="Líneas Entradas (E)" value={selectedHab.LineasE} />
                      </Col>
                    )}
                    {selectedHab.LineasEntradas > 0 && (
                      <Col span={12}>
                        <Statistic title="Líneas Entradas Totales" value={selectedHab.LineasEntradas} />
                      </Col>
                    )}
                  </Row>
                </Card>
              </Col>
            )}
          </Row>
        </div>
      </Modal>
    );
  };

  return (
    <div style={{ padding: isMobile ? '12px' : '24px' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        {/* Header con estadísticas */}
        <Card
          // title={
          //   <Space>
          //     <HomeOutlined />
          //     <span>Sistema de Gobernanta</span>
          //   </Space>
          // }
          extra={
            <Space>
              <Button
                icon={<ReloadOutlined />}
                onClick={fetchHabitaciones}
                loading={loading}
              >
                Actualizar
              </Button>
            </Space>
          }
          style={{ borderRadius: '8px' }}
        >
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} md={12}>
              <Text strong>Estadísticas: </Text>
              <Space wrap>
                <Tag color="blue">Total: {estadisticas.total}</Tag>
                <Tag color="red">Sucias: {estadisticas.sucias}</Tag>
                <Tag color="green">Limpias: {estadisticas.limpias}</Tag>
                <Tag color="#ffa8a8" style={{ color: '#333' }}>Bloqueadas: {estadisticas.bloqueadas}</Tag>
                <Tag color="orange">Incidencias: {estadisticas.conIncidencias}</Tag>
                <Tag color="purple">Check-In: {estadisticas.conCheckIn}</Tag>
                <Tag color="cyan">Check-Out: {estadisticas.conCheckOut}</Tag>
              </Space>
            </Col>
            <Col xs={24} md={12}>
              <Space wrap style={{ float: isMobile ? 'left' : 'right' }}>
                <Select
                  placeholder="Piso"
                  style={{ width: 100 }}
                  allowClear
                  onChange={(value) => setFilters({ ...filters, piso: value })}
                >
                  {[...new Set(habitaciones.map(h => h.piso))].sort((a, b) => a - b).map(piso => (
                    <Option key={piso} value={piso}>{piso}</Option>
                  ))}
                </Select>
                <Select
                  placeholder="Estado"
                  style={{ width: 140 }}
                  allowClear
                  onChange={(value) => setFilters({ ...filters, estado: value })}
                >
                  <Option value="sucia">Sucia</Option>
                  <Option value="limpia">Limpia</Option>
                  <Option value="bloqueada">Bloqueada</Option>
                  <Option value="en-limpieza">En Limpieza</Option>
                  <Option value="en-revision">En Revisión</Option>
                  <Option value="checkin">Con Check-In</Option>
                  <Option value="checkout">Con Check-Out</Option>
                </Select>
                <Select
                  placeholder="Incidencias"
                  style={{ width: 130 }}
                  allowClear
                  onChange={(value) => setFilters({ ...filters, incidencias: value })}
                >
                  <Option value="con">Con Incidencias</Option>
                  <Option value="sin">Sin Incidencias</Option>
                </Select>
                <Button
                  icon={<FilterOutlined />}
                  onClick={() => setFilters({
                    piso: null,
                    estado: null,
                    incidencias: null,
                    checkin: null,
                    checkout: null
                  })}
                >
                  Limpiar
                </Button>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Leyenda de estados */}
        <Card size="small" title="Leyenda de Estados">
          <Row gutter={[16, 8]}>
            <Col xs={12} sm={8} md={6} lg={4}>
              <Space>
                <CloseCircleOutlined style={{ color: estadoColors.sucia }} />
                <Text>Sucia</Text>
              </Space>
            </Col>
            <Col xs={12} sm={8} md={6} lg={4}>
              <Space>
                <CheckCircleOutlined style={{ color: estadoColors.limpia }} />
                <Text>Limpia</Text>
              </Space>
            </Col>
            <Col xs={12} sm={8} md={6} lg={4}>
            <Space>
                <CloseCircleOutlined style={{ color: estadoColors.bloqueada }} />
                <Text>Bloqueada</Text>
            </Space>
            </Col>            
            <Col xs={12} sm={8} md={6} lg={4}>
              <Space>
                <ReloadOutlined style={{ color: estadoColors['en-limpieza'] }} />
                <Text>En Limpieza</Text>
              </Space>
            </Col>
            <Col xs={12} sm={8} md={6} lg={4}>
              <Space>
                <ExclamationCircleOutlined style={{ color: estadoColors['en-revision'] }} />
                <Text>En Revisión</Text>
              </Space>
            </Col>
            <Col xs={12} sm={8} md={6} lg={4}>
              <Space>
                <ExclamationCircleOutlined style={{ color: estadoColors.incidencia }} />
                <Text>Incidencia</Text>
              </Space>
            </Col>
            <Col xs={12} sm={8} md={6} lg={4}>
              <Space>
                <LoginOutlined style={{ color: estadoColors.checkin }} />
                <Text>Check-In</Text>
              </Space>
            </Col>
            <Col xs={12} sm={8} md={6} lg={4}>
              <Space>
                <LogoutOutlined style={{ color: estadoColors.checkout }} />
                <Text>Check-Out</Text>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Habitaciones por piso */}
        {renderHabitaciones()}

        {/* Modal de detalles */}
        {renderDetalleModal()}

        {renderModalIncidencias()}
      </Space>
    </div>
  );
};

export default GobernantaPage;